import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { FileUploadControl } from "@cloudpivot/form/src/common/controls/file-upload-control";
import { UploadStatus } from "@cloudpivot/form/src/common/controls/upload-control";
import PCImagePreview from "@cloudpivot/form/src/common/components/pc-image-preview.vue";
import FileList from "./file-list.vue";
import Compressor from 'compressorjs';
import { Icon, Button, Upload, Modal } from "@h3/antd-vue";
let PcUpload = class PcUpload extends FileUploadControl {
    constructor() {
        super(...arguments);
        this.previewVisible = false;
        this.previewIndex = 0;
        this.fileList = [];
        this.eventList = [];
        this.uploadFileList = [];
        this.timer = null;
    }
    get listType() {
        // 上传图片为 picture-card 样式, 上传文件显示为 text 样式
        return this.isImage ? "picture-card" : "text";
    }
    get showBatchDownload() {
        return this.canBatchDownload && this.fileList.length > 0;
    }
    get canDounload() {
        const fileDown = this.fileList.filter((f) => {
            return f.status === "done";
        });
        if (fileDown.length === this.fileList.length) {
            return true;
        }
        else {
            return false;
        }
    }
    get isReadonly() {
        if (this.ctrl) {
            return this.readonly;
        }
        return true;
    }
    unsubscribe() {
        if (this.commandSubscription) {
            this.commandSubscription.unsubscribe();
        }
    }
    setControl() {
        if (this.ctrl && this.ctrl.value) {
            this.toFilelist(this.ctrl.value);
        }
        else {
            // this.fileList = [];
            this.uploadFileList = this.fileList = [];
        }
        this.unsubscribe();
        this.listenCommand();
    }
    handleValueChange(value, changeInfo) {
        // 图片有两种情况,
        // 上传图片和被动赋值.
        // 如果是主动上传图片则不应该 调用this.toFilelist.
        // 如果是赋值则可以调用this.toFilelist. 目前看来每次更新赋值前 value会被设置null.
        if (!value) {
            this.toFilelist(value);
        }
        else if (value.length > 0) {
            this.toFilelist(value);
        }
        else if (value.length &&
            (!this.uploadFileList || this.uploadFileList.length === 0)) {
            this.toFilelist(value);
        }
        else if (value.length === this.uploadFileList.length) {
        }
    }
    toFilelist(val) {
        if (!val) {
            this.uploadFileList = this.fileList = [];
            return;
        }
        //说明此时的数据还未经过转换
        if (Array.isArray(val) && val.length > 0 && val[0].mimeType) {
            val = this.convertFileData(val);
            if (!val)
                return;
        }
        this.uploadFileList = this.fileList = val.map((y) => {
            let x = "";
            if (!y.uid && y.response && y.response.data) {
                x = y.response.data;
            }
            else {
                x = y;
            }
            if (x.response && x.response.data) {
                x.url = this.getDownloadUrl(x.response.data);
            }
            let mineType = null;
            if (x.response && x.response.data) {
                mineType = x.response.data.mimeType;
                if (mineType) {
                    let typeArr = mineType.split("/");
                    if (Array.isArray(typeArr) && typeArr.length === 2) {
                        mineType = typeArr[1];
                    }
                }
            }
            if (mineType &&
                !["jpg", "jpeg", "png", "gif", "bmp", "svg", "tif"].includes(mineType)) {
                x.status = "fileToImg";
            }
            let status = UploadStatus.Uploading;
            switch (x.status) {
                case "removed":
                    status = UploadStatus.Delete;
                    break;
                case "fileToImg":
                    status = UploadStatus.FileToImg;
                    break;
                case "done":
                    status = UploadStatus.Done;
                    break;
                case "error":
                    status = UploadStatus.Error;
                    break;
                case "uploading":
                    status = UploadStatus.Uploading;
                    break;
                default:
                    status = x.status;
                    break;
            }
            x.status = status;
            return x;
        });
        this.fileList.map((f) => {
            if (f.status === UploadStatus.FileToImg) {
                this.rmFile(f);
            }
        });
        this.fileList = this.fileList.filter((f) => f.status !== UploadStatus.FileToImg);
        this.uploadFileList = this.fileList;
    }
    listenCommand() {
        const _this = this;
        this.commandSubscription = this.ctrl.commander.subscribe((cmd) => {
            switch (cmd.name) {
                case "clear":
                    _this.fileList = [];
                    _this.ctrl.value = null;
                    break;
                default:
                    break;
            }
        });
    }
    showError(msg) {
        this.$message.error(msg);
    }
    beforeUpload(file) {
        if (!this.checkFileType(file.name, this.showError)) {
            return false;
        }
        if (!this.checkFileSize(file, this.showError)) {
            return false;
        }
        if (!this.checkImageNumber(this.showError)) {
            return false;
        }
        if (!this.checkImageNameLength(file.name, this.showError)) {
            return false;
        }
        file.uploadTime = new Date().getTime();
        // file.thumbUrl = getFileUrl(file);
        let userInfo = window.sessionStorage.getItem("user");
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
        }
        else {
            userInfo = { name: "" };
        }
        file.uploadName = window.sessionStorage.getItem("uploadName")
            || userInfo.name;
        if (this.controlOpts.compressible) {
            const quality = this.controlOpts.imageQuality;
            return new Promise((resolve, reject) => {
                console.log(file.size / 1024 / 1024, 'file---');
                // this.transformFile(file, quality).then((res: any) => {
                this.compressFile(file, quality).then((res) => {
                    res.uid = file.uid;
                    resolve(res);
                }).catch(error => {
                    reject(error);
                });
            });
        }
        else {
            return true;
        }
    }
    onChange(info) {
        clearTimeout(this.timer);
        let fileList = [...info.fileList];
        if (this.max > -1 && (fileList.length > this.max)) {
            fileList = fileList.slice(0, this.max);
        }
        if (this.isReadonly) {
            return;
        }
        this.uploadFileList = fileList.filter((f) => f.status && !(f.status === UploadStatus.Delete || f.status === "removed"));
        //保存文件状态
        let { file } = info;
        // 保存文件上传进度
        this.eventList = this.uploadFileList.map((f) => {
            if (f.response && f.response.errcode === 50000) {
                f.status = UploadStatus.Error;
            }
            return f;
        });
        const files = this.uploadFileList
            .map((f) => {
            // 有服务errorcode = 50000 但是上传状态返回为done的情况 估计是上传接口先上传到服务器  再通过ftp还是oss转移到其他地方
            let serverResponse = f.response;
            if (serverResponse) {
                let errorCode = serverResponse.errcode;
                if (errorCode === 50000) {
                    return {
                        uid: f.uid,
                        name: f.name,
                        size: f.size,
                        type: f.type,
                        thumbUrl: f.thumbUrl,
                        status: UploadStatus.Error,
                        response: f.response,
                        uploadTime: f.uploadTime,
                        uploadName: f.uploadName
                    };
                }
            }
            let status = UploadStatus.Uploading;
            switch (f.status) {
                case "removed":
                    status = UploadStatus.Delete;
                    break;
                case "fileToImg":
                    status = UploadStatus.FileToImg;
                    break;
                case "done":
                    status = UploadStatus.Done;
                    break;
                case "error":
                    status = UploadStatus.Error;
                    break;
                case "uploading":
                    status = UploadStatus.Uploading;
                    break;
                default:
                    status = f.status;
                    break;
            }
            return {
                uid: f.uid,
                name: f.name,
                size: f.size,
                type: f.type,
                thumbUrl: status === UploadStatus.Done ? f.thumbUrl : '',
                status: status,
                response: f.response,
                uploadTime: f.uploadTime,
                uploadName: f.uploadName,
            };
        });
        this.timer = setTimeout(() => {
            super.onFilesChange(files);
        }, 100);
    }
    transformFile(file, imageQuality) {
        const that = this;
        let files;
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    let base64 = that.compress(img, file['type'], imageQuality);
                    files = that.dataURLtoFile(base64, file.name); // 如果后台接收类型为base64的话这一步可以省略
                    // console.log(files, 'files3---')
                    console.log(files.size / 1024 / 1024, 'files---');
                    resolve(files);
                };
            };
        });
    }
    compressFile(file, imageQuality) {
        return new Promise((resolve) => {
            new Compressor(file, {
                quality: imageQuality / 100,
                success: (result) => {
                    // console.log(result, 'result')
                    console.log(result.size / 1024 / 1024, 'result---');
                    let newFile = new File([result], file.name, { type: file.type });
                    resolve(newFile);
                },
                error: (err) => {
                    resolve({});
                    console.log(err.message);
                },
            });
        });
    }
    /*压缩
    * 绘制canvas
    * 判断 是否大于100万像素 通过瓦片绘制
    * */
    compress(img, type, imageQuality) {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d');
        //瓦片canvas
        let tCanvas = document.createElement("canvas");
        let tCtx = tCanvas.getContext("2d");
        let width = img.width;
        let height = img.height;
        //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
        let ratio;
        if ((ratio = width * height / 4000000) > 1) {
            console.log("大于400万像素");
            ratio = Math.sqrt(ratio);
            width /= ratio;
            height /= ratio;
        }
        else {
            ratio = 1;
        }
        canvas.width = width;
        canvas.height = height;
        //铺底色
        ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        //如果图片像素大于100万则使用瓦片绘制
        let count;
        if ((count = width * height / 1000000) > 1) {
            console.log("超过100W像素");
            count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
            // 计算每块瓦片的宽和高
            let nw = ~~(width / count);
            let nh = ~~(height / count);
            tCanvas.width = nw;
            tCanvas.height = nh;
            for (let i = 0; i < count; i++) {
                for (let j = 0; j < count; j++) {
                    tCtx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
                    ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
                }
            }
        }
        else {
            ctx.drawImage(img, 0, 0, width, height);
        }
        //进行最小压缩
        let MinData = canvas.toDataURL(type, imageQuality / 100);
        tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
        return MinData;
    }
    // base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
    dataURLtoFile(dataurl, filename) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }
    /**
     * @des 删除文件
     */
    rmFile(file) {
        this.removedFile(file);
    }
    onRemovedImg(file) {
        super.removedFile(file);
    }
    handleCancel() {
        this.previewVisible = false;
    }
    handlePreview(file) {
        if (!this.isImage) {
            this.download(file.response.data);
            return;
        }
        this.previewIndex = this.uploadFileList.findIndex(item => item.uid === file.uid);
        this.previewVisible = true;
    }
    downloadAll() {
        this.downloadBatch();
    }
    destroyed() {
        super.destroyed();
        this.unsubscribe();
    }
    created() {
        this.init();
    }
};
PcUpload = tslib_1.__decorate([
    Component({
        name: "pc-upload",
        components: {
            AIcon: Icon,
            AButton: Button,
            AUpload: Upload,
            AModal: Modal,
            ImgPreview: PCImagePreview,
            FileList,
        },
    })
], PcUpload);
export default PcUpload;
